
import WrapperFormQuestion from '@/app/Survey/components/WrapperFormQuestion.vue';
import QuestionMixin from '@/app/Survey/FormComponents/QuestionMixin';
import { BFormGroup, BFormInput, BFormTextarea } from 'bootstrap-vue';
import { debounceFn } from 'debounce-decorator-ts';
import { Component, Mixins } from 'vue-property-decorator';

@Component({ components: { WrapperFormQuestion, BFormTextarea, BFormGroup, BFormInput } })
export default class SimpleTextComponent extends Mixins(QuestionMixin) {
    public value: string = null;

    public mounted() {
        this.value = this.singleAnswer?.text;
    }

    @debounceFn(500)
    public input(): void {
        this.setAnswer({ text: this.value });
    }

    public blur(): void {
        this.value = this.value?.trim() ?? null;
        this.setAnswer({ text: this.value });
    }
}
